import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../components/Login';
import { Link } from 'react-router-dom';
import '../App.css';

function LoginPage() {
    const navigate = useNavigate();

    const handleLogin = (loginSuccessful, userRole, username) => {
        if (loginSuccessful) {
            if (userRole === 'administrator') {
                navigate('/admin-page');
            } else {
                navigate('/device-manager');
            }
        } else {
            console.log('Login failed. Please try again.');
        }
    };

    return (
        <div className="login-page">
            <h1 style={{ fontFamily: "Arial Rounded MT Bold, sans-serif" }}>RealIoT</h1>
            <p>Войти в личный кабинет:</p>
            <Login onLogin={handleLogin} /> {/* Pass handleLogin as a prop */}

            <div className="login-options">
                <p>
                    <Link to="/register">Чтобы зарегистрироваться, щелкните здесь.</Link>
                </p>
                <p>
                    <Link to="/password-recovery">Забыли пароль? Восстановить здесь.</Link>
                </p>
            </div>
        </div>
    );
}

export default LoginPage;